import config from "../../config/index";
import requestOptions from "@/helpers/RequestOptions";
import handleResponse from "@/helpers/HandleResponses";
import handleBlobResponse from "@/helpers/HandleBlobResponses";

export const workerService = {
  addCasualWorker,
  changeCasualWorkerPhoto,
  addCasualWorkerBank,
  addCasualWorkerStatutory,
  UpdateCasualWorker,
  UpdateCasualWorkerBank,
  UpdateCasualWorkerStatutory,
  GetCasualWorkers,
  GetCasualWorkerDetail,
  GetCasualWorkerOtherDetail,
  removeCasualWorker,
  exportCasualWorker,
  ImportCasualWorker,
  downloadCasualWorkerTemplate,
  updateCasualWorkerProfileInfo
};

function addCasualWorker(
  companyId,
  rankId,
  firstName,
  lastName,
  email,
  phone,
  designationId,
  companyUnitId,
  joinDate
) {
  var req = {
    rankId,
    companyId,
    firstName,
    lastName,
    email,
    phone,
    designationId,
    companyUnitId,
    joinDate
  };
  return fetch(
    `${config.apiurl}/casualworker/PostCasualWorker`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function changeCasualWorkerPhoto(file, id) {
  let formData = new FormData();
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/casualworker/PostCasualWorkerPhoto/${id}`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function ImportCasualWorker(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/casualworker/ImportCasualWorker`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function exportCasualWorker(id) {
  return fetch(
    `${config.apiurl}/CasualWorker/ExportAllCasualWorkers/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function updateCasualWorkerProfileInfo(id, model) {
  return fetch(
    `${config.apiurl}/casualworker/UpdateCasualWorker/${id}`,
    requestOptions.put(model)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function downloadCasualWorkerTemplate(id) {
  return fetch(
    `${config.apiurl}/casualworker/downloadCasualWorkerTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function addCasualWorkerBank(
  employeeId,
  bankAccountNumber,
  bankName,
  bvnNumber
) {
  var req = {
    workerId: employeeId,
    bankAccountNumber,
    bankName,
    bvnNumber
  };
  return fetch(
    `${config.apiurl}/casualworker/PostCasualWorkerBank`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addCasualWorkerStatutory(employeeId, tax) {
  tax.workerId = employeeId;
  return fetch(
    `${config.apiurl}/casualworker/PostCasualWorkerTax`,
    requestOptions.post(tax)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function UpdateCasualWorker(
  id,
  companyId,
  rankId,
  firstName,
  lastName,
  email,
  phone,
  designationId,
  companyUnitId,
  joinDate
) {
  var req = {
    id,
    rankId,
    companyId,
    firstName,
    lastName,
    email,
    phone,
    designationId,
    companyUnitId,
    joinDate
  };
  return fetch(
    `${config.apiurl}/casualworker/UpdateCasualWorker/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function UpdateCasualWorkerStatutory(employeeId, tax) {
  tax.workerId = employeeId;
  return fetch(
    `${config.apiurl}/casualworker/UpdateCasualWorkerTax/${tax.id}`,
    requestOptions.put(tax)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function UpdateCasualWorkerBank(
  id,
  employeeId,
  bankAccountNumber,
  bankName,
  bvnNumber
) {
  var req = {
    workerId: employeeId,
    bankAccountNumber,
    bankName,
    bvnNumber
  };
  return fetch(
    `${config.apiurl}/casualworker/UpdateCasualWorkerBank/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function GetCasualWorkers(unitId) {
  return fetch(
    `${config.apiurl}/casualworker/GetCasualWorkersbyunit/${unitId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function removeCasualWorker(employeeId) {
  // console.log(employeeId)
  return fetch(
    `${config.apiurl}/casualworker/DeleteCasualWorker/${employeeId}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function GetCasualWorkerDetail(employeeId) {
  return fetch(
    `${config.apiurl}/casualworker/GetWorker/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function GetCasualWorkerOtherDetail(employeeId) {
  return fetch(
    `${config.apiurl}/casualworker/GetCasualWorkerOtherDetail/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}



// WEBPACK FOOTER //
// ./src/services/workerService.js